import { useStore } from '../../../../hooks/useStore';
import Popup from '../../../../components/common-components/pop-up/Popup';
import CommonButton from '../../../../components/common-components/button/CommonButton';
import styles from './NewOvertimePopup.module.css';

const RejectionReasonPopup = () => {
  const { popupStore, overtimeStore } = useStore();

  const handleClose = () => {
    popupStore.setIsRejectionReasonOpen(false);
    overtimeStore.setSelectedOvertime(null);
  };

  const selectedOvertime = overtimeStore.selectedOvertime;

  if (!selectedOvertime || !selectedOvertime.rejectionReason) {
    return null;
  }

  return (
    <Popup
      isOpen={popupStore.isRejectionReasonOpen}
      onClose={handleClose}
      title="Red Sebebi"
      footer={
        <CommonButton type="cancel" onClick={handleClose}>
          Kapat
        </CommonButton>
      }
    >
      <div className={styles.formGroup}>
        <label className={styles.formLabel}>Red Sebebi</label>
        <div
          style={{
            padding: '12px',
            backgroundColor: '#f8f9fa',
            borderRadius: '6px',
            border: '1px solid #e0e0e0',
            minHeight: '100px',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {selectedOvertime.rejectionReason}
        </div>
      </div>
    </Popup>
  );
};

export default RejectionReasonPopup;
